// All asset URLs and shared brand image references for patrice.studio
export const IMG = {
  peonyBouquetDark:
    "https://customer-assets.emergentagent.com/job_peony-redesign/artifacts/dpz7u4um_flower%20garden.jpeg",
  studioHeader:
    "https://customer-assets.emergentagent.com/job_peony-redesign/artifacts/vu4lmovl_IMG_7827.JPG",
  headerReference:
    "https://customer-assets.emergentagent.com/job_peony-redesign/artifacts/jfob208q_fa51e2d4-7e52-4e99-ad44-40b2c12851ef.JPG",
  sgbReputation:
    "https://customer-assets.emergentagent.com/job_peony-redesign/artifacts/mgy3fmge_4gfhh.png",
  sgbWebdesign:
    "https://customer-assets.emergentagent.com/job_peony-redesign/artifacts/d2y6ymhw_54.png",
  sgbAndroid:
    "https://customer-assets.emergentagent.com/job_peony-redesign/artifacts/drdhrv3b_%D0%BA%D0%BB%D0%B8%D0%BF%D0%B0%D1%80%D1%82%20%D0%B1%D0%B5%D1%81%D0%BF%D0%BB%D0%B0%D1%82%D0%BD%D0%BE.jpeg",

  // Editorial peony images for the 5 Erlebnisräume — final, curated by Patrice (06/2026)
  peonyFoto:
    "https://customer-assets.emergentagent.com/job_peony-redesign/artifacts/6q1xmmek_DSC00604_1a.jpg",
  peonyKunst:
    "https://customer-assets.emergentagent.com/job_peony-redesign/artifacts/1yqy66tw_IMG_3783%20Tonality%20Toning%20Antique000.jpg",
  peonyKlang:
    "https://customer-assets.emergentagent.com/job_peony-redesign/artifacts/buvp9dwg_IMG_5073.JPG",
  peonyKreativ:
    "https://customer-assets.emergentagent.com/job_peony-redesign/artifacts/x4o95180_Screenshot%202026-06-05%20234743.jpg",
  peonyAtelier:
    "https://customer-assets.emergentagent.com/job_peony-redesign/artifacts/huqh3rqs_Smart%20AI%20Tools%20.jpg",

  // CLEAR SIGNAL hero — Frau auf Würfel + Instagram (für sichtbargutbewertet.de)
  clearSignalHero:
    "https://customer-assets.emergentagent.com/job_peony-redesign/artifacts/l1dvm0ze_51.png",

  // Schrift-Referenz (Amsterdam Four) — nur als Referenz, nicht direkt eingebettet
  patriceSignatureReference:
    "https://customer-assets.emergentagent.com/job_peony-redesign/artifacts/28n23dgh_Schrift%20Patrice.jpg",

  // Backwards compatibility aliases
  get peonyBilder() { return this.peonyKunst; },
  get peonyMusik() { return this.peonyKlang; },
  get peonyWort() { return this.peonyKreativ; },
};

export const BRAND = {
  name: "patrice.studio",
  signature: "Patrice Schreiter",
  initials: "P S",
  established: "EST. 2026",
  tagline_de: "Zuhause meiner Marke. Ein digitales Atelier.",
  tagline_en: "A digital atelier — the home of my work.",
};
